import { BOX_SHADOW_FIELDS, INPUT_COLOR_BORDER } from "../../../utils/colors";
import { BORDER_RADIUS } from "../../../utils/constants";

export const STEPPER_BACKGROUND = "#f9fafc";
export const STEPPER_STEP_PENDING_CIRCLE = "#edf0f4";
export const STEPPER_STEP_DONE_CIRCLE = "#d7e8f9";
export const STEPPER_STEP_DONE_TEXT = "#2b5e90";

export const subtleBorderSx = {
  border: `1px solid ${INPUT_COLOR_BORDER}`,
  borderRadius: BORDER_RADIUS,
  boxShadow: BOX_SHADOW_FIELDS,
};

export const subtleDividerSx = {
  borderColor: INPUT_COLOR_BORDER,
};
